<template>
  <div class="col-12 inline-link">
    <div
      @mouseenter="hover('in')"
      @mouseleave="hover('out')"
      :style="InlineLinkStyle"
      ref="inlineLink"
      :class="[isDisabled ? 'isDisabled' : '', 'link paragraph14']"
      tabindex="0"
      @click="[isDisabled ? '' : linkClicked()]"
      @keyup.enter="[isDisabled ? '' : linkClicked()]"
    >
      {{ $t(text) }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'InlineLink',
  props: {
    text: {
      type: String,
      required: false,
      default: 'InlineLink',
    },
    isDisabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    color: {
      type: String,
      required: false,
      default: '#616161',
    },
  },
  methods: {
    hover(mode) {
      if (!this.$refs.inlineLink) {
        return;
      }
      if (this.isDisabled) {
        // do not nothing
      } else if (mode === 'in') {
        this.iconHovered = true;
        this.$refs.inlineLink.style.color = this.getHooverTextColor;
        this.$refs.inlineLink.style.textDecoration = 'underline';
      } else {
        this.iconHovered = false;
        this.$refs.inlineLink.style.color = this.color;
        this.$refs.inlineLink.style.textDecoration = 'underline';
      }
    },
    linkClicked() {
      if (this.isDisabled === false) {
        this.$emit('inlineLinkClicked');
      }
    },
  },
  computed: {
    InlineLinkStyle() {
      return {
        color: `${this.color}`,
      };
    },
    getHooverTextColor() {
      switch (this.color) {
        case 'var(--darkRed)':
          return '#df4311';
        case '#616161':
          return '#343434';
        case '#ffffff':
          return '#ececec';
        case '#fab62f':
          return '#ec9f05';
        case 'var(--primaryBlue)':
          return '#389de2';
        case '#83b74e':
          return '#70a33b';
        default:
          return '#343434';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.inline-link {
  .link {
    cursor: pointer;
    font-weight: 500;
    font-size: 14px;
    text-decoration: underline;
    user-select: none;
    display: inline-block;
  }
  .isDisabled {
    cursor: pointer;
    font-weight: bold;
    opacity: 0.32;
    text-decoration: underline;
    user-select: none;
  }
}
</style>
